import { useState, useCallback } from 'react';

export const TAB_IDS = ['basic', 'dimensions', 'equipment', 'notes'] as const;
export type TabId = (typeof TAB_IDS)[number];

/** Fields that belong to each tab — used for cross-tab error detection */
export const TAB_FIELDS: Record<TabId, string[]> = {
  basic: ['name', 'description', 'tankType', 'setupDate'],
  dimensions: ['grossVolume', 'netVolume', 'length', 'width', 'height', 'sumpAvailable', 'supplySystem'],
  equipment: ['equipment', 'equipmentNotes'],
  notes: ['notes'],
};

interface UseAquariumFormTabsReturn {
  activeTab: TabId;
  setActiveTab: (id: TabId) => void;
  tabHasError: (id: TabId, errorFields: string[]) => boolean;
}

export function useAquariumFormTabs(initialTab: TabId = 'basic'): UseAquariumFormTabsReturn {
  const [activeTab, setActiveTabState] = useState<TabId>(initialTab);

  const setActiveTab = useCallback((id: TabId) => {
    setActiveTabState(id);
  }, []);

  const tabHasError = useCallback((id: TabId, errorFields: string[]): boolean => {
    const fields = TAB_FIELDS[id];
    return errorFields.some((f) => fields.includes(f));
  }, []);

  return { activeTab, setActiveTab, tabHasError };
}
